/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SaveGeneralInformationMetaAttributesAsync$Params {
  orid: number;
      body: {
[key: string]: string;
}
}

export function saveGeneralInformationMetaAttributesAsync(http: HttpClient, rootUrl: string, params: SaveGeneralInformationMetaAttributesAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, saveGeneralInformationMetaAttributesAsync.PATH, 'post');
  if (params) {
    rb.path('orid', params.orid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

saveGeneralInformationMetaAttributesAsync.PATH = '/api/Organizations/saveGeneralInformation/{orid}';
